"use client";

import { useEffect, useRef } from "react";
import { SUPPORT_BAR_HEIGHT_CSS_VAR } from "./supportBarConstants";
const PHONE_NUMBER = "(415) 429 - 8330";
const PHONE_HREF = "tel:+14154298330";
const PhoneSolidIcon = ({
  className = ""
}: {
  className?: string;
}) => <svg viewBox='0 0 17 17' fill='currentColor' role='img' aria-hidden='true' className={className} data-sentry-element="svg" data-sentry-component="PhoneSolidIcon" data-sentry-source-file="SupportBar.tsx">
    <path d='M13.6596 16.9887L12.9656 17C12.9323 16.931 12.8481 16.975 12.78 16.9677C11.8373 16.8639 10.9646 16.5789 10.1022 16.1871C7.76173 15.1236 5.68381 13.5909 3.96632 11.6772C3.12888 10.7444 2.38156 9.76458 1.73854 8.68877C0.975052 7.41219 0.242416 5.80263 0.0318324 4.32774C0.023507 4.26995 0.0695417 4.17692 0 4.14607L0.00930487 3.34006C0.085213 2.85774 0.211074 2.36855 0.578371 2.00423L2.21407 0.380476C2.72437 -0.125846 3.51724 -0.128784 4.02999 0.383414L6.39391 2.74266C6.94731 3.29501 6.94682 4.09024 6.38412 4.65582L4.93991 6.1077C4.85567 6.19241 4.83217 6.32169 4.88016 6.42892C5.11131 6.94749 5.36842 7.42051 5.70731 7.88277C6.57365 9.06533 7.57906 10.1167 8.7407 11.0103C9.30781 11.4466 9.88471 11.7923 10.5267 12.093C10.6609 12.1557 10.7721 12.1689 10.8877 12.0543L12.375 10.5765C12.899 10.0554 13.6904 10.0422 14.2242 10.5765L16.6185 12.971C17.144 13.4969 17.1156 14.2867 16.6043 14.8068L15.2056 16.2288C14.7766 16.6646 14.2511 16.9197 13.66 16.9897L13.6596 16.9887Z' data-sentry-element="path" data-sentry-source-file="SupportBar.tsx" />
  </svg>;
const SupportBar = () => {
  const barRef = useRef<HTMLDivElement>(null);

  // Publish the live height so fixed elements (search pills on the detail and
  // vacation-rentals pages) can sit below the bar even when it wraps to two
  // lines at narrower widths.
  useEffect(() => {
    const el = barRef.current;
    if (!el) return;
    const root = document.documentElement;
    const sync = () => {
      root.style.setProperty(SUPPORT_BAR_HEIGHT_CSS_VAR, `${Math.ceil(el.getBoundingClientRect().height)}px`);
    };
    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.setProperty(SUPPORT_BAR_HEIGHT_CSS_VAR, "0px");
    };
  }, []);
  return <div ref={barRef} className='flex w-full items-center justify-center gap-2 bg-accent-500 px-4 py-2 text-center tracking-[0.64px] text-white' data-sentry-component="SupportBar" data-sentry-source-file="SupportBar.tsx">
      <PhoneSolidIcon className='h-[15px] w-[15px] shrink-0 md:h-[17px] md:w-[17px]' data-sentry-element="PhoneSolidIcon" data-sentry-source-file="SupportBar.tsx" />
      <p className='text-[11px] leading-[1.5] text-white xsm:text-[13px] md:text-[16px]'>
        <a href={PHONE_HREF} className='font-bold text-white hover:underline'>
          {PHONE_NUMBER}
        </a>{" "}
        <span className='font-medium uppercase text-white'>
          Travel advisor support hours:{" "}
        </span>
        <span className='font-bold text-white'>
          Call or text: Monday - Friday 8-8pm CT | Saturday &amp; Sunday 10-6pm
          CT
        </span>
      </p>
    </div>;
};
export default SupportBar;